<section class="container-style">
  <form [formGroup]="form">
    <p>Digite el primer número de documento con el que desea comenzar.</p>
    <div class="row">
      <div class="col field-consecutive">
        <app-custom-input-number formControlName="consecutive" [labelText]="'Documento Nro'" [required]="true">
        </app-custom-input-number>
      </div>
      <div class="col field-button">
        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined" (onClick)="send()">
        </app-custom-button>
      </div>
    </div>
  </form>
</section>